import React, { useEffect, useState } from 'react';
import { Button, Form, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Role } from '../../../models';

export function NewUserPage(props: { onSaved: () => void }) {
  const { Option } = Select;

  const [loading, setLoading] = useState(false);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState<(Role & { key: string })[]>();

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = () => {
    setRolesLoading(true);
    apiClient
      .get('roles?minimal=true')
      .then(response => {
        const responseRoles: Role[] = response.data;
        const responseData = responseRoles.map(role => {
          return {
            key: role.id,
            ...role,
          };
        });
        setRoles(responseData);
        setRolesLoading(false);
      })
      .catch((reason: any) => {
        setRolesLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onFinish = (values: any) => {
    setLoading(true);
    if (!values.roleIds) {
      values.roleIds = [];
    }
    apiClient
      .post('users', values)
      .then(() => {
        setLoading(false);
        props.onSaved();
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  return (
    <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} onFinish={onFinish}>
      <Form.Item
        label="E-posta"
        name="emails"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            validator: async (_, values) => {
              if (!values || !values.length) {
                return;
              }
              const pattern = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/;
              const regExp = new RegExp(pattern);
              for (let i = 0; i < values.length; i++) {
                if (!regExp.test(values[i])) {
                  return Promise.reject(new Error('Geçersiz e-posta adresi'));
                }
              }
            },
          },
        ]}
      >
        <Select mode="tags" notFoundContent={null} />
      </Form.Item>
      <Form.Item label="Roller" name="roleIds">
        <Select mode="multiple" disabled={rolesLoading} notFoundContent={null} optionFilterProp="label">
          {roles?.map(role => (
            <Option key={role.key} value={role.id} label={role.name}>
              {role.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
